
import Vue from 'vue';
import { ListData, HeaderActions } from '@root/modules/navigation/types/navigation';
import CustomerMenuDropdown from './CustomerMenuDropdown.vue';

interface Data {
  showCustomerMenuDropdown: boolean;
}

interface Props {
  misc: Record<string, ListData>;
  data: {
    isLoggedIn: boolean;
    profile: {
      displayName: string | null;
      id: number;
      email: string;
      firstName: string | null;
      lastName: string | null;
      avatar: string | null;
    };
  };
  logout: () => void;
  openLoginModal: () => void;
}

interface Methods {
  closeMenu: () => void;
  toggleSidebar: () => void;
  toggleLogin: () => void;
  toggleAction: (type: HeaderActions['type'], value: HeaderActions['value']) => void;
}

interface Computed {
  isSitemapOpen: boolean;
  isSearchOpen: boolean;
  isSidebarOpen: boolean;
  backgroundColor: string | null;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    CustomerMenuDropdown,
  },
  props: {
    misc: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    logout: {
      type: Function,
      required: true,
    },
    openLoginModal: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      showCustomerMenuDropdown: false,
    };
  },
  computed: {
    isSitemapOpen() {
      return this.$store.getters['navigation/getHeaderAction']('sitemap');
    },
    isSearchOpen() {
      return this.$store.getters['navigation/getHeaderAction']('search');
    },
    isSidebarOpen() {
      return this.$store.getters['navigation/getHeaderAction']('sidebar');
    },
    backgroundColor() {
      if (!this.data.isLoggedIn) {
        return null;
      }

      const userName = this.data.profile.firstName ? this.data.profile.firstName : this.data.profile.displayName;
      if (userName) {
        let hash = 0;
        let bgColor = null;

        for (let i = 0; i < userName.length; i += 1) {
          hash = userName.charCodeAt(i) + ((hash << 5) - hash);
        }

        // eslint-disable-next-line unicorn/number-literal-case
        const c = (hash & 0x00ffffff).toString(16).toUpperCase();
        bgColor = '00000'.substring(0, 6 - c.length) + c;

        return `#${bgColor}`;
      }

      return null;
    },
  },
  methods: {
    toggleLogin() {
      if (this.data.isLoggedIn) {
        this.showCustomerMenuDropdown = !this.showCustomerMenuDropdown;
      } else {
        this.openLoginModal();
      }
    },
    toggleAction(type, value) {
      this.$store.commit('navigation/setHeaderAction', { type, value });
    },
    closeMenu() {
      if (!this.isSitemapOpen) {
        return;
      }
      this.toggleAction('sitemap', false);
    },
    toggleSidebar() {
      this.toggleAction('sidebar', !this.isSidebarOpen);
    },
  },
});
